export const NFT_TYPE = {
  GOLD: "GOLD",
  BAMBOO: "BAMBOO",
} as const;
export type NFT_TYPE = (typeof NFT_TYPE)[keyof typeof NFT_TYPE];
